<template>
    <v-container class="fill-height justify-start align-start">
        <v-row>
            <v-col>
                <v-card>
                    <v-toolbar>
                        <v-toolbar-title>Locations</v-toolbar-title>
                        <v-text-field label="Search" variant="solo" density="compact" v-model="search" hide-details
                            class="mr-6" style="max-width: 20rem;" @keydown.enter.prevent="loadReset"
                            :clearable="true"></v-text-field>
                        <v-btn prepend-icon="mdi-plus" variant="outlined" class="mr-3"
                            :to="'/locations/create'">Create</v-btn>
                    </v-toolbar>
                    <v-progress-linear indeterminate :active="loading"></v-progress-linear>
                    <v-table>
                        <colgroup>
                            <col />
                            <col />
                            <col style="width: 150px;" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th class="text-left">Name</th>
                                <th class="text-left">Update</th>
                                <th class="text-left">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in locations" @click="$router.push('/locations/' + item.locationId)" class="click-tr"
                                :key="item.locationId">
                                <td>{{ item.name }}</td>
                                <td> </td>
                                <td>
                                    <v-btn icon="mdi-delete" variant="text"
                                        @click="deleteEnity(item.locationId, item.code)"></v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </v-table>
                    <v-divider></v-divider>
                    <v-toolbar color="surface">
                        <v-toolbar-title></v-toolbar-title>
                        <span density="compact" class="mr-3 free-text">Item per page:</span>
                        <v-select variant="outlined" density="compact" hide-details :items="perPageItems"
                            v-model="perPage" style="max-width: 6rem;" @update:modelValue="loadReset"></v-select>
                        <span density="compact" class="ml-4 mr-4 free-text">{{ offset + 1 }} - {{ curentPage() }} of {{
                            count }}</span>
                        <v-btn icon="mdi-arrow-left" density="compact" variant="text" :disabled="offset == 0"
                            @click="previousPage"></v-btn>
                        <v-btn icon="mdi-arrow-right" density="compact" variant="text" class="ml-4 mr-12"
                            :disabled="curentPage() >= count" @click="nextPage"></v-btn>
                    </v-toolbar>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog max-width="500" v-model="dialogOn">
            <v-card title="Delete Location">
                <v-card-text>Are you sure you whant to delete the location {{ deletedName }}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text="Dismist" @click="dialogOn = false"></v-btn>
                    <v-btn text="Delete" color="error" @click="confirmDelete"></v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar">{{ message }}
            <template v-slot:actions>
                <v-btn icon="mdi-close" variant="text" @click="snackbar = false" :timeout="timeout"></v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>

<script>
import LocationApi from '../services/LocationApi'
import { useStore } from '../services/store'

export default {
    name: 'LocationPage',
    data() {
        return {
            locations: [],
            perPage: 25,
            search: "",
            offset: 0,
            count: 0,
            perPageItems: [ 10, 15, 25, 50 ],
            locationId: 0,
            deletedName: "",
            dialogOn: false,
            snackbar: false,
            message: "",
            timeout: 2000,
            loading: false
        }
    },
    mounted() {
        const store = useStore();
        var storedPerPage = store.perPage;
        if(storedPerPage && !isNaN(storedPerPage)) {
            this.perPage = parseInt(storedPerPage, 10);
        }
        this.load();
    },
     methods: {
        load() {
            let output = this.offset == 0 ? 'count' : ''
            this.loading = true;
             LocationApi.search({offset: this.offset, limit: this.perPage, output: output, search: this.search})
                    .then((response) => {
                        if(response.data && response.data.locations &&Array.isArray(response.data.locations)){
                            this.locations = response.data.locations;
                        }
                        if(response.data && response.data.count) {
                            this.count = response.data.count;
                        }
                    }).finally(() => this.loading = false)
        },
        loadReset() {
            this.offset = 0;
            const store = useStore();
            store.perPage = this.perPage;
            this.load();
        },
        curentPage() {
            let crtPage = this.offset + this.perPage;
            if(crtPage > this.count)
                return this.count;
            return crtPage;
        },
        previousPage() {
            this.offset -= this.perPage;
            this.load()
        },
        nextPage() {
            this.offset += this.perPage;
            this.load()
        },
        deleteEnity(id, code) {
            this.locationId = id;
            this.deletedCode = code;
            this.dialogOn = true;
        },
        confirmDelete() {
             LocationApi.delete(this.locationId)
                    .then((response) => {
                        if(response.data) {
                            this.message = response.data.state.message;
                            this.snackbar = true;
                            this.dialogOn = false;
                            this.load()
                        }
                    }).catch((error) => {
                        this.message = error.message;
                        this.snackbar = true;
                        this.dialogOn = false;
                    })
        }
    }
}
</script>